import Quickview from './Quickview'

export default {
  Quickview
}



// WEBPACK FOOTER //
// ./src/app/configuration/TargetRetailWalmart/theme/components/quickview/index.js